
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[page]",
      function () {
        return require("private-next-pages/blog/page/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[page]"])
      });
    }
  